import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import "./styles.css";
import { getTokenValidation } from "../../api/api";
import CheckBox from "../checkBox";
import Button from "../button";
import { setConfirmationAppointment } from "../../api/api";
import ModalResponseComponent from "./modalResponse";

const CancelAppointmentComponent = () => {
  const [searchParams] = useSearchParams();
  let token = searchParams.get("k");
  const [showModal, setShowModal] = useState(true);
  const [showModalFinalResponse, setShowFinalResponse] = useState(false);
  const [response, setResponse] = useState();
  const [responseConfirmationAppointment, setResponseConfirmationAppointment] =
    useState();
  const [textAreaValue, setTextAreaValue] = useState("");
  const [selectedCancelReason, setSelectedCancelReason] = useState();

  useEffect(() => {
    token && getTokenValidation(token, onResponse, onError);
  }, []);

  const onResponse = (response) => {
    let responseGSBase = JSON.parse(response);
    if (responseGSBase.error) {
      onError(responseGSBase.error);
      return;
    }
    if (responseGSBase.message) {
      return;
    }
    if (responseGSBase) {
      setResponse(responseGSBase);
    }
  };

  const onError = (error) => {
    console.log(error);
    alert(error);
    window.location.href = "https://clinicaalejandria.es/";
  };

  const checkCancelReasonCheckBox = (reason) => {
    if (JSON.stringify(reason) === JSON.stringify(selectedCancelReason)) {
      return true;
    } else {
      return false;
    }
  };

  const onConfirm = () => {
    if (!selectedCancelReason) {
      alert("Por favor, selecciona un motivo.");
      return;
    }

    let confirmationAppointment = {
      id: response.id,
      confirmation: false,
      cancelReason: selectedCancelReason,
      observations: textAreaValue,
    };

    setConfirmationAppointment(
      token,
      confirmationAppointment,
      onResponseConfirmationAppointment,
      onError
    );

    setShowModal(false);
  };

  const onResponseConfirmationAppointment = (response) => {
    setResponseConfirmationAppointment(JSON.parse(response));
    setShowFinalResponse(true);
    let responseGSBase = JSON.parse(response);
    if (responseGSBase.error) {
      onError(responseGSBase.error);
      return;
    }
    if (responseGSBase.message) {
      return;
    }
  };

  return (
    <div className="containerCancelAppointment">
      <iframe
        title="alejandría web"
        className="CAObject"
        src="https://clinicaalejandria.es/"
      />
      {showModal && response && (
        <div className="modalBackgroundContainer">
          <div className="modalContainer">
            <div className="modalTitleContainer">CANCELAR CITA</div>
            <div className="modalTextNameContainer">
              {response?.patient?.name}
            </div>
            <div>
              {`Próximo ${response.dayOfWeek} ${response.date} a las ${response.hour} h. con ${response?.doctor?.name}`}
            </div>
            <div className="modalReasonTitleContainer">MOTIVO</div>
            {response &&
              response.cancelReasonList &&
              response.cancelReasonList.length > 0 && (
                <div className="modalCancelReasonContainer">
                  {response.cancelReasonList.map((reason, index) => {
                    return (
                      <CheckBox
                        key={index}
                        text={reason.title}
                        margin={"0 0 12px 0"}
                        isChecked={checkCancelReasonCheckBox(reason)}
                        onChange={() => setSelectedCancelReason(reason)}
                      />
                    );
                  })}
                </div>
              )}
            <textarea
              className="modalTextArea"
              placeholder={"Escribe el motivo..."}
              value={textAreaValue}
              onChange={(event) => setTextAreaValue(event.target.value)}
            />
            <Button text={"CONFIRMAR"} onClick={() => onConfirm()} />
          </div>
        </div>
      )}
      {showModalFinalResponse && (
        <ModalResponseComponent
          responseConfirmationAppointment={responseConfirmationAppointment}
          setShowFinalResponse={setShowFinalResponse}
        />
      )}
    </div>
  );
};

export default CancelAppointmentComponent;
